export default {
  activityType: {
    RESTAURANT: "Ristorante",
    ATTRACTION: "Esperienza",
    GENERIC_SERVICE: "Servizio",
  },
  cuisine: {
    italian: "Italiana",
    spanish: "Spagnola",
    canarian: "Canaria",
    mediterranean: "Mediterranea",
    japanese: "Giapponese",
    chinese: "Cinese",
    thai: "Thailandese",
    indian: "Indiana",
    mexican: "Messicana",
    american: "Americana",
    french: "Francese",
    greek: "Greca",
    middle_eastern: "Mediorientale",
    seafood: "Frutti di mare",
    steakhouse: "Steakhouse",
    vegetarian: "Vegetariana/Vegana",
    pizza: "Pizza",
    sushi: "Sushi",
    ramen: "Ramen",
    tapas: "Tapas",
    fast_food: "Fast food",
    cafe: "Caffè/Bistrò",
    fusion: "Fusion",
    international: "Internazionale",
    other: "Altro",
  },
  menuCategory: {
    APPETIZER: "Antipasto",
    FIRST_COURSE: "Primo",
    SECOND_COURSE: "Secondo",
    SIDE_DISH: "Contorno",
    SALAD: "Insalata",
    PIZZA: "Pizza",
    SOUP: "Zuppa",
    DESSERT: "Dolce",
    FRUIT: "Frutta",
    CHEESE: "Formaggio",
    BEVERAGE: "Bevanda",
    WINE: "Vino",
    COCKTAIL: "Cocktail",
    COFFEE: "Caffè",
    KIDS_MENU: "Menù bambini",
    SPECIAL: "Speciale",
  },
  lang: {
    en: "Inglese",
    it: "Italiano",
    es: "Spagnolo",
    de: "Tedesco",
  },
} as const;
